import { Observable, throwError, timer } from 'rxjs'
import { mergeMap, finalize } from 'rxjs/operators'

//https://www.learnrxjs.io/learn-rxjs/operators/error_handling/retrywhen

interface GenericRetryStrategyArgs {
    maxRetryAttempts?: number
    scalingDuration?: number[] // delay to wait after each try, will take last index if the try is bigger 
                               // than scalingDuration.length
    excludedStatusCodes?: number[]
} 

export const genericRetryStrategy = ({
  maxRetryAttempts = 3,
  scalingDuration = [1000],
  excludedStatusCodes = []
}: GenericRetryStrategyArgs = {}) => (attempts: Observable<any>) => {
    
    const getRetryDelay = (tryNumber): number => {
        if(tryNumber < scalingDuration.length) {
            return scalingDuration[tryNumber]
        }

        return scalingDuration[scalingDuration.length - 1]
    }

    return attempts.pipe(
        mergeMap((error, i) => {
            const retryAttempt = i + 1
            // if maximum number of retries have been met
            // or response is a status code we don't wish to retry, throw error
            if (
                retryAttempt > maxRetryAttempts ||
                excludedStatusCodes.find(e => e === error.status)
            ) {
                return throwError(error)
            }

            const delay = getRetryDelay(retryAttempt)
            console.debug(
                `genericRetryStrategy: Attempt ${retryAttempt}: retrying in ${delay}ms`
            )
            return timer(delay)
        }),
        finalize(() => console.debug('genericRetryStrategy: We are done!'))
    )
}